import React from "react";
import { Box } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import Logo from "../../assets/images/logo.png";
import { C, FONT_BODY, FONT_DISPLAY, FOCUS_RING, RADIUS, VISUALLY_HIDDEN } from "../../utils/designTokens";

export const CHECKOUT_HEADER_HEIGHT = 64;

/**
 * Checkout's own header: the way back to the menu, the brand, and the
 * reassurance that payment is secure. No search, sidebar or other navigation,
 * so nothing pulls the customer away from finishing the order.
 */
function CheckoutHeader({ backTo = "/" }) {
  return (
    <Box
      component="header"
      sx={{ position: "sticky", top: 0, zIndex: 1100, bgcolor: C.bg, borderBottom: `1px solid ${C.border}` }}
    >
      <Box
        sx={{
          maxWidth: 1240,
          mx: "auto",
          height: CHECKOUT_HEADER_HEIGHT,
          px: { xs: 1.5, sm: 3 },
          display: "grid",
          gridTemplateColumns: "1fr auto 1fr",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Box
          component={RouterLink}
          to={backTo}
          sx={{
            justifySelf: "start",
            display: "inline-flex",
            alignItems: "center",
            gap: 0.25,
            height: 44,
            pr: 1,
            borderRadius: RADIUS.control,
            fontFamily: FONT_BODY,
            fontSize: 14,
            fontWeight: 600,
            color: C.ink,
            textDecoration: "none",
            whiteSpace: "nowrap",
            "&:hover": { color: C.redLink },
            ...FOCUS_RING,
          }}
        >
          <ChevronLeftRoundedIcon aria-hidden="true" sx={{ fontSize: 22, ml: -0.5 }} />
          Back to menu
        </Box>

        <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
          <Box component="img" src={Logo} alt="" sx={{ width: 36, height: 36, objectFit: "contain" }} />
          <Box
            component="span"
            sx={{
              display: { xs: "none", sm: "inline" },
              fontFamily: FONT_DISPLAY,
              fontWeight: 800,
              fontSize: 21,
              letterSpacing: "-0.02em",
              color: C.ink,
              whiteSpace: "nowrap",
            }}
          >
            RushMyFood
          </Box>
          <Box component="span" sx={{ ...VISUALLY_HIDDEN, display: { xs: "inline", sm: "none" } }}>
            RushMyFood
          </Box>
        </Box>

        <Box
          sx={{
            justifySelf: "end",
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            fontFamily: FONT_BODY,
            fontSize: 14,
            fontWeight: 600,
            color: C.green,
            whiteSpace: "nowrap",
          }}
        >
          <LockRoundedIcon aria-hidden="true" sx={{ fontSize: 18 }} />
          <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>Secure checkout</Box>
          <Box component="span" sx={{ display: { xs: "inline", sm: "none" } }}>Secure</Box>
        </Box>
      </Box>
    </Box>
  );
}

export default React.memo(CheckoutHeader);
